import React from "react";
import PropTypes from "prop-types";
import { Container, Row, Col, Collapse as RCollapse } from "reactstrap";

import { Dropzone, MyDraggable as Draggable } from "../components/Core";
import HoverBar from "../components/HoverBar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import state from "../state";

import Icon from "../components/Icons";

import { generateStyle, l, setOverLay } from "../functions";

import { connect } from "react-redux";
import isEqual from "lodash/isEqual";

const mapStateToProps = (state) => {
  return {
    currentLang: state.rootReducer.currentLang || 1,
    elementToEdit: state.rootReducer.elementToEdit || null,
    settings: state.rootReducer?.appearanceSettings || {},
    elementOptions: state.rootReducer.elementOptions || [],
  };
};

class Collapse extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      payload: this.props.payload,
      headingContent: null,
      showEditor: false,
      initialElements: [],
      frameVersion: Math.random(),
      fieldHeight: "fit-content",
      open: 1,
    };

    this.columns = {
      xl: [12],
      lg: [12],
      md: [12],
      sm: [12],
      xs: [12],
    };
  }

  componentDidMount() {
    this.setState({
      initialElements: this.props.initialElements,
      frameVersion: Math.random(),
    });
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    // const { id, dropzoneID, parentID } = this.props;
    const { id, dropzoneID, parentID, payload } = this.props;

    if (
      JSON.stringify(prevState.initialElements) !==
      JSON.stringify(this.state.initialElements)
    ) {
      let updatedObject = {};

      updatedObject.initialElements = this.state.initialElements;
      updatedObject.fields = this.state.initialElements;

      state.updateElement(id, dropzoneID, parentID, updatedObject);
    }

    if (
      prevState.headingContent !== this.state.headingContent &&
      this.state.headingContent !== null
    ) {
      clearTimeout(this.changeValues);
      this.changeValues = setTimeout(() => {
        const { payload } = this.props;

        if (payload === null) payload = this.props.options.payload;

        this.setState(
          {
            payload: {
              ...payload,
              headingContent: this.state.headingContent,
            },
          },
          () => {
            state.updateElement(id, dropzoneID, parentID, {
              payload: this.state.payload,
            });
          }
        );
      }, 500);
    }
  }

  componentWillReceiveProps(nextProps) {
    // console.log("these are initial elements on prop change", this.props);
    // console.log("these are upcoming elements", this.)

    if (!isEqual(this.props.initialElements, nextProps.initialElements)) {
      this.setState({
        initialElements: this.props.initialElements,
        frameVersion: Math.random(),
      });
    }
    if (
      JSON.stringify(nextProps.payload) !== JSON.stringify(this.state.payload)
    )
      this.setState({
        payload: nextProps.payload,
        open: nextProps.payload?.datas?.collapseOpen,
      });
  }

  _onDrop = (data, cb) => {
    // no need to ask id and name again
    if (data.payload && data.payload.dropped) {
      return cb(data);
    }

    // This can be an async call or some modal to fetch data

    let name = data.name;
    const id = "gk-" + Math.floor(Math.random() * 10000 + 1);

    return cb({
      ...data,
      name,
      id,
      elementId: data.id,
      payload: {
        dropped: true,
        ...this.props.elementOptions[data.id]?.payload,
      },
    });
  };

  _collapse = () => {
    this.setState({
      open: this.state.open === 0 ? 1 : 0,
    });
  };

  _generateTabHeadStyle = (payload) => {
    const { tabBackground, tabBorder } = payload;
    // console.log(tabBackground, tabBorder);

    let style = {};

    //boder style
    style.borderTopLeftRadius = tabBorder?.lt || 0;
    style.borderTopRightRadius = tabBorder?.rt || 0;
    style.borderColor = tabBorder?.border_color || "black";

    if (tabBorder?.border_target === "border") {
      style.borderStyle = tabBorder?.border_style || null;

      style.borderWidth = tabBorder?.border_width || null;
    }
    if (tabBorder?.border_target === "borderTop") {
      style.borderTopStyle = tabBorder?.border_style || null;
      style.borderTopWidth = tabBorder?.border_width || null;
    }

    if (tabBorder?.border_target === "borderRight") {
      style.borderRightStyle = tabBorder?.border_style || null;
      style.borderRightWidth = tabBorder?.border_width || null;
    }
    if (tabBorder?.border_target === "borderLeft") {
      style.borderLeftStyle = tabBorder?.border_style || null;
      style.borderLeftWidth = tabBorder?.border_width || null;
    }
    if (tabBorder?.border_target === "borderBottom") {
      style.borderBottomStyle = tabBorder?.border_style || null;
      style.borderBottomWidth = tabBorder?.border_width || null;
    }

    // background

    if (tabBackground?.backgroundColor) {
      style.backgroundColor = tabBackground?.backgroundColor;
    }

    if (tabBackground?.backgroundImage) {
      style.backgroundImage = tabBackground?.backgroundImage
        ? `url(${tabBackground.backgroundImage})`
        : null;
      style.backgroundSize = tabBackground.backgroundSize || null;
      style.backgroundRepeat = tabBackground.backgroundRepeat || null;
      style.backgroundPosition = tabBackground.backgroundPosition || null;
      style.backgroundAttachment = tabBackground.parallax ? "fixed" : null;
    }
    /*

{
    "backgroundColor": "rgba(0,0,0,1)",
    "backgroundImage": "https://cdn.groovekart.com/xxxxxxxx/img/m3q6CmGFgPV3jaYe0Q8oBRryYDEhbN.webp",
    "backgroundSize": "initial",
    "backgroundRepeat": "repeat",
    "backgroundPosition": "center center",
    "overlayOpacity": 24,
    "parallax": true
}

    */

    return style;
  };

  _generateContentStyle = (payload) => {
    const { contentBackground, contentBorder } = payload;

    let style = {};

    //boder style
    style.borderBottomLeftRadius = contentBorder?.lb || 0;
    style.borderBottomRightRadius = contentBorder?.rb || 0;
    style.borderColor = contentBorder?.border_color || "black";

    if (contentBorder?.border_target === "border") {
      style.borderStyle = contentBorder?.border_style || null;

      style.borderWidth = contentBorder?.border_width || null;
    }
    if (contentBorder?.border_target === "borderTop") {
      style.borderTopStyle = contentBorder?.border_style || null;
      style.borderTopWidth = contentBorder?.border_width || null;
    }

    if (contentBorder?.border_target === "borderRight") {
      style.borderRightStyle = contentBorder?.border_style || null;
      style.borderRightWidth = contentBorder?.border_width || null;
    }
    if (contentBorder?.border_target === "borderLeft") {
      style.borderLeftStyle = contentBorder?.border_style || null;
      style.borderLeftWidth = contentBorder?.border_width || null;
    }

    if (contentBorder?.border_target === "borderBottom") {
      style.borderBottomStyle = contentBorder?.border_style || null;
      style.borderBottomWidth = contentBorder?.border_width || null;
    }

    // background

    if (contentBackground?.backgroundColor) {
      style.backgroundColor = contentBackground?.backgroundColor;
    }

    if (contentBackground?.backgroundImage) {
      style.backgroundImage = contentBackground?.backgroundImage
        ? `url(${contentBackground.backgroundImage})`
        : null;
      style.backgroundSize = contentBackground.backgroundSize || null;
      style.backgroundRepeat = contentBackground.backgroundRepeat || null;
      style.backgroundPosition = contentBackground.backgroundPosition || null;
      style.backgroundAttachment = contentBackground.parallax ? "fixed" : null;
    }
    /*

{
    "backgroundColor": "rgba(0,0,0,1)",
    "backgroundImage": "https://cdn.groovekart.com/xxxxxxxx/img/m3q6CmGFgPV3jaYe0Q8oBRryYDEhbN.webp",
    "backgroundSize": "initial",
    "backgroundRepeat": "repeat",
    "backgroundPosition": "center center",
    "overlayOpacity": 24,
    "parallax": true
}

    */

    return style;
  };

  _tabSpacing = (settings) => {
    const { tabSpacing: spacing } = settings;
    return {
      marginTop: (spacing && spacing.marginTop) || null,
      marginBottom: (spacing && spacing.marginBottom) || null,
      marginRight: (spacing && spacing.marginRight) || null,
      marginLeft: (spacing && spacing.marginLeft) || null,

      paddingTop: (spacing && spacing.paddingTop) || null,
      paddingBottom: (spacing && spacing.paddingBottom) || null,
      paddingRight: (spacing && spacing.paddingRight) || null,
      paddingLeft: (spacing && spacing.paddingLeft) || null,
    };
  };

  _generateTags = (preview) => {
    let { id } = this.props;
    let { payload } = this.state;

    if (payload === null) payload = this.props.options.payload;

    const settings =
      payload["settings+" + this.props.currentDevice] || payload.settings;

    const {
      headingTag: MyHeading = "h1",
      headingText,
      collapseOpen,
    } = payload.datas || {};

    const cssSettings = generateStyle(payload, "container");
    const cssSettingsText = {
      ...generateStyle(payload, "text", MyHeading.toUpperCase()),
    };

    const tabHeadCss = this._generateTabHeadStyle(settings);
    const tabContentCss = this._generateContentStyle(settings);
    const tabSpacing = this._tabSpacing(settings);
    // console.log(currentText);
    // console.log(this.props);

    const dropzoneProps = {
      initDone: true,
      parentID: id,
    };
    return (
      <Container fluid={payload.fullContainer} style={cssSettings}>
        {setOverLay(payload)}
        <Row>
          <Col xs={12} className="col">
            <div className="tab-container">
              <div style={{ ...tabHeadCss, ...tabSpacing }}>
                <MyHeading
                  style={cssSettingsText}
                  onClick={this._collapse}
                  aria-controls={`collapse-field-${id}`}
                  aria-expanded={this.state.open ? true : false}
                >
                  {headingText}
                </MyHeading>
              </div>
              <RCollapse
                isOpen={this.state.open ? true : false}
                dimension={"height"}
                style={tabContentCss}
              >
                <div id={`collapse-field-${id}`}>
                  <Dropzone
                    {...dropzoneProps}
                    initialElements={this.state.initialElements}
                    id={`canvas-${id}-1`}
                    key={`canvas-${id}-1`}
                    onDrop={this._onDrop}
                    version={`canvas-${this.state.frameVersion}`}
                  />
                </div>
              </RCollapse>
            </div>
          </Col>
        </Row>
      </Container>
    );
  };

  render() {
    const {
      dropzoneID,
      parentID,
      showBasicContent,
      showPreview,
      id,
      dropzoneProps,
      payload,
      ...rest
    } = this.props;

    if (showBasicContent) {
      return (
        <Draggable {...this.props} side={true}>
          <span className="dragger">
            {(Array.isArray(rest.icon) && (
              <FontAwesomeIcon icon={rest.icon} />
            )) || <Icon icon={rest.icon} />}
            <span>{l(rest.subName || rest.name)}</span>
          </span>
        </Draggable>
      );
    }

    if (showPreview) return this._generateTags(true);

    return (
      <Draggable {...this.props} minify={true}>
        <HoverBar
          datas={this.props}
          style={payload}
          parent={parentID}
          element={{ id, dropzoneID, parentID, payload }}
        />
        {this._generateTags(false)}
      </Draggable>
    );
  }
}

Collapse.propTypes = {
  id: PropTypes.string.isRequired,
  showBasicContent: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(Collapse);
